var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"view-console-configuration"},[_vm._l((_vm.configurationValues),function(value,key){return [_c('dt',{attrs:{"scope":"row"}},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('dd',[_c('pre',[_c('code',[_vm._v(_vm._s(JSON.stringify(value, null, 2)))])])])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f135456","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/ConsoleConfiguration.vue
// module id = 237
// module chunks = 0